import { Typography } from "@mui/material";
import React from "react";
import { useAppSelector, AppState } from "../store";

import DynamicDashboardLayout from "../components/common/DynamicDashboardLayout";

const dashBoardData = [
  {
    size: 4,
    navigate: "/studies",
    title: "Studies",
    icon: "ScienceOutlined",
    list: [
      [{ status: "New", count: "1", color: "info" }],
      [{ status: "Updated", count: "4", color: "primary" }],
    ],
  },
  {
    size: 4,
    navigate: "/accessions",
    title: "Accessions",
    icon: "AssignmentTurnedInOutlined",
    list: [
      [{ status: "New", count: "3", color: "info" }],
      [{ status: "Updated", count: "2", color: "primary" }],
    ],
  },
  {
    size: 4,
    navigate: "/enrollment",
    title: "Enrollment",
    icon: "Group",
    list: [
      [{ status: "New", count: "2", color: "info" }],
      [{ status: "Updated", count: "1", color: "primary" }],
    ],
  },
  {
    size: 4,
    navigate: "/inventory",
    title: "Inventory",
    icon: "InventoryOutlined",
    list: [
      [{ status: "New", count: "1", color: "info" }],
      [{ status: "Updated", count: "1", color: "primary" }],
    ],
  },
  {
    size: 4,
    navigate: "/reports",
    title: "Reports",
    icon: "ArticleOutlined",
    list: [
      [{ status: "New", count: "1", color: "info" }],
      [{ status: "Updated", count: "4", color: "primary" }],
    ],
  },
  {
    size: 4,
    navigate: "/sites-lab",
    title: "Site, Labs & Vendors",
    icon: "BusinessOutlined",
    list: [
      [
        { status: "New Sites", count: "1", color: "info" },
        { status: "New Labs", count: "2", color: "info" },
        { status: "New Vendors", count: "3", color: "info" },
      ],
      [
        { status: "Updated Sites", count: "2", color: "primary" },
        { status: "Updated Labs", count: "2", color: "primary" },
        { status: "Updated Vendors", count: "2", color: "primary" },
      ],
    ],
  },
];

const Dashboard: React.FunctionComponent<any> = () => {
  const userObj = useAppSelector(
    (state: AppState) => state.commonSlice.userObj
  );
  const { first_name, last_name } = userObj;

  return (
    <>
      <Typography variant="h4" className="wordBreakAll fw500">
        Welcome {`${first_name} ${last_name}`},
      </Typography>

      <DynamicDashboardLayout dashBoardData={dashBoardData} />
    </>
  );
};

export default Dashboard;
